
import { GridMetaData, createUrlSearchParams } from "models/grids/GridMetaData";
import { IProject, IProjectOverview } from "models/projects/Project";
import { IWorkItemTask } from "models/work-items/IWorkItemTask";

const projectDummy = {
    Id: 1,
    Name: "Creative Aerobics: Fuelling Imagination in the 21st Century",
    ProjectProgress: "In Progress",
    StartDate: new Date().toDateString(),
    EndDate: new Date().toDateString(),
    WorkspaceInstanceName: "Books US College",
    SAGEOwnerId: 1,
    FinanceDivisionId: 1,
    WorkItemTemplateId: 1,
    WorkspaceInstanceID: 1,
    ProblemFlag: 1,
    ProjectProgressSortOrder: 1,
    ProjectURL: ""
}

export default class ProjectsService {

    static timeout(ms: number | undefined) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    static getProjectsByStatus = async (status: string, allProjects = false, gridMetaData: GridMetaData, accessToken: string): Promise<IProject[]> => {
        return await fetch(process.env.REACT_APP_API_URL + `/api/v3.0/projects/my/${status}/${allProjects}`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(gridMetaData)
        })
            .then(r => r.json());
    }

    static getProjectsReportByStatus = async (status: string, allProjects = false, gridMetaData?: GridMetaData) => {
        return await fetch(process.env.REACT_APP_API_URL + `/api/v3.0/projects/export/${status}/${allProjects}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(gridMetaData)
        })
            .then(r => { return r });
    }

    static getProjectOverview = async (projectId: string | undefined, accessToken: string): Promise<IProjectOverview> => {
        const headers = {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        };
        const resp = await fetch(process.env.REACT_APP_API_URL + `/api/v3/projects/${projectId}`, { headers, mode: 'cors' })
        return resp.json();
    }

    static getAllProjectWorkItemsReport = async (projectId: string | undefined, workItemStatus: string, accessToken: string) => {
        return await fetch(process.env.REACT_APP_API_URL + `/api/v3.0/projects/export/${projectId}/workitems/${workItemStatus}/all`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
                mode: 'cors'
            }
        })
            .then(r => { return r });
    }

    static getProjectWorkItemWorkflowTasks = async (workflowId: number, workItemStatus: string = 'all', accessToken: string): Promise<IWorkItemTask[]> => {
        const headers = {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        };
        const resp = await fetch(process.env.REACT_APP_API_URL + `/api/v3/projects/workflow/${workflowId}/tasks/${workItemStatus}`, { headers, mode: 'cors' })
        return resp.json();
    }

    static updateProjectProblemLogResolution = async (problemLogId: number, resolution: boolean, accessToken: string): Promise<number> => {
        console.log('resolved in api call: ', resolution)
        const problemLogResolutionData = {
            problemLogId: problemLogId,
            resolution: resolution
        };
        const headers = {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        };
        const resp = await fetch(process.env.REACT_APP_API_URL + `/api/v3/projects/problemlog`, {
            method: 'PUT',
            headers,
            mode: 'cors',
            body: JSON.stringify(problemLogResolutionData)
        })
        return resp.json();
    }
}
